<template>
  <div
    class="spring-festival-course-reservation"
    ref="parentScroll"
    :style="{ height: screenHeight }"
    v-pageBuried
    data-page-buried="BG_JM_EVENTS_kcdk_HOME"
  >
    <AppBar :opacity="0" @share="bindShowShare" v-if="isApp"> </AppBar>
    <div class="container" v-if="activityData">
      <WxOpenLaunchApp :extinfo="extinfo"></WxOpenLaunchApp>
      <img
        class="bg-image"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/b93ffc78c934cbd845f82379a124fe60_wh=1500_2120.png"
        alt=""
      />
      <div class="my-prize" @click="bindShowMyPrize">我的奖品</div>
      <div class="city-container">
        <!-- <div class="city" v-if="activityData.city_name">
          <span class="iconfont icon-dingwei"></span>
          <span>{{ activityData.city_name }}</span>
        </div> -->
      </div>
      <div class="tab-container" ref="tab">
        <div class="tab-list">
          <div
            class="tab-item"
            ref="tabItem"
            :class="{ 'tab-item-active': index == curNav }"
            v-for="(item, index) in navList"
            :key="index"
            @click="bindClickNav(item, index)"
          >
            <img
              class="gift-image"
              v-if="item.prize_state == 3"
              src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/618ffb5509866bd65f7945fce7d3c39a_wh=108_108.png"
              alt=""
            />
            <div class="item-day">{{ item.week_desc }}</div>
            <div class="item-date">{{ item.day_title }}</div>
            <div class="item-status" v-if="isApp">{{ item.statusText }}</div>
          </div>
        </div>
      </div>
      <div class="tab-view-container">
        <div
          class="tab-view-item"
          v-for="(item, index) in navList"
          :key="index"
          v-show="index == curNav"
        >
          <div class="tab-wrapper" v-if="item.loaded">
            <div class="wrapper-padding">
              <!-- 活动参与情况 -->
              <JoinStatusComponent
                @appointment="bindAppointment"
                @address="bindFillAddress"
                @prize="bindShowMyPrize"
                :addressData="addressData"
                :data="item"
              ></JoinStatusComponent>
              <!-- 锦鲤时段 -->
              <PeriodComponent :data="item"></PeriodComponent>
              <!-- 锦鲤榜 -->
              <PrizeData :data="item" :list="bigAwardData"></PrizeData>
            </div>
          </div>
        </div>
      </div>
      <ActivityRule
        :rules="activityData.act_info && activityData.act_info.rules"
      ></ActivityRule>
      <img
        class="logo"
        src="https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/4f2b1012cb188dae6e1743fc5ec99cc5_wh=1125_273.png"
        alt=""
      />
    </div>
    <AppLoading class="app-loading" v-if="isLoading" />
    <!-- 我的奖品 -->
    <van-popup v-model="showMyPrize" position="bottom">
      <MyPrize
        :show="showMyPrize"
        :data="activityData && activityData.prize_record"
        @close="showMyPrize = false"
        :addressData="addressData"
        @address="bindFillAddress"
      />
    </van-popup>
    <!-- 填写地址 -->
    <van-popup v-model="showFillAddress" class="fill-address" position="bottom">
      <FillAddress
        ref="fillAddress"
        :show="showFillAddress"
        :data="addressData"
        @close="showFillAddress = false"
        @setAddress="setAddressData"
      />
    </van-popup>
    <!-- 所有中奖名单 -->
    <van-popup v-model="showNotQualified" position="center">
      <NotQualified
        :type="errorType"
        :show="showNotQualified"
        @close="showNotQualified = false"
      />
    </van-popup>
    <!-- 分享组件 -->
    <ShareComponent
      v-model="showShare"
      :options="iconList"
      @cancel="bindCancel"
      @select="bindSelect"
      :qrcodeUrl="qrcodeUrl"
    />
  </div>
</template>

<script>
import AppBar from './components/nav-bar.vue'
import { eventObj } from '@/components/app/share/share-method.js'
import AppLoading from '@/components/app/loading/loading.vue'
import ShareComponent from '@/components/app/share/share.vue'
import MyPrize from './components/my-prize.vue'
import FillAddress from './components/fill-address.vue'
import JoinStatusComponent from './components/join-status.vue'
import PeriodComponent from './components/period-component.vue'
import PrizeData from './components/prize-data.vue'
import ActivityRule from './components/rules.vue'
import NotQualified from './components/not-qualified.vue'
import WxOpenLaunchApp from '@/components/wx/wx-open-app.vue'
export default {
  components: {
    ShareComponent,
    AppLoading,
    AppBar,
    MyPrize,
    FillAddress,
    JoinStatusComponent,
    PeriodComponent,
    PrizeData,
    ActivityRule,
    NotQualified,
    WxOpenLaunchApp
  },
  data() {
    return {
      isApp: true,
      navBarOpacity: 0,
      showShare: false,
      qrcodeUrl: '',
      extinfo: '',
      iconList: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友',
          id: 1
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈',
          id: 2
        }
      ],
      shareOptions: {
        //分享参数
        url: '',
        desc: '打卡上课 得小米大奖',
        title: '上课踩中惊喜时段，100%得实物礼！',
        thumbnail:
          'https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/b3faa5302c75f6f7d1b7fae1aa7a92d1_wh=750_750.png'
      },
      errorType: 2,
      isLoading: true,
      showMyPrize: false,
      showFillAddress: false,
      showNotQualified: false,
      curNav: 0,
      activityData: null,
      navList: [],
      bigAwardData: null,
      addressData: {
        user_name: '',
        phone: '',
        address: ''
      },
      screenHeight: '100vh'
    }
  },
  computed: {},
  created() {
    this.init()
    this.getActivityInfo()
    this.getBigAward()
    this.getAddressData()
  },
  mounted() {
    //this.$refs.parentScroll.addEventListener("scroll", this.bindScroll, { passive: false });
  },
  methods: {
    init() {
      /* 进来时设置容器高度为屏幕高度，解决在弹出层填写地址时，键盘弹起导致弹出层抖动的问题 */
      // this.screenHeight = window.innerHeight ? (window.innerHeight + "px") : "100vh";
      this.isApp = this.$betterwe.isApp()
      let url = location.origin + location.pathname
      this.extinfo = '/web?url=' + encodeURIComponent(url)
      this.qrcodeUrl = location.origin + location.pathname
      window.onPageResumed = async () => {
        if (this.navList.length) {
          this.getActivityInfo(this.navList[this.curNav]?.date)
        }
      }
    },
    bindClickNav(item, index) {
      let res = this.allowShowErrToast(this.activityData.user_state)
      if (res) {
        return
      }
      this.curNav = index
      this.getActivityInfo(item.date)
    },
    bindToReserveCourse() {},
    bindShowMyPrize() {
      let res = this.allowShowErrToast(this.activityData.user_state, 'myPrize')
      if (res) {
        return
      }
      this.showMyPrize = true
    },
    bindshowNotQualified() {
      this.showNotQualified = true
      let type = this.errorType
      let value =
        type == 2 ? 'BG_JM_EVENTS_kcdk_cmhytc' : 'BG_JM_EVENTS_kcdk_fhytc'
      this.$http.bindH5UMA('BG_JM_EVENTS_kcdk_tc', value)
    },
    bindFillAddress() {
      this.showMyPrize = false
      setTimeout(() => {
        this.showFillAddress = true
      }, 300)
    },
    bindConfirmAddress() {},
    bindShowShare() {
      this.$http.bindH5UMA('CLICK_JM_EVENTS_kcdk_SHARE')
      let res = this.allowShowErrToast(this.activityData.user_state)
      if (res) {
        return
      }
      this.showShare = true
    },
    bindCancel() {
      this.showShare = false
    },
    async bindSelect(options) {
      this.showShare = false
      let shareOptions = Object.assign({}, this.shareOptions)
      switch (options.id) {
        // 分享链接到微信好友
        case 1:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxFriend(shareOptions)
          break
        // 分享链接到微信朋友圈
        case 2:
          shareOptions.url = this.qrcodeUrl
          eventObj.shareLinkToWxCircle(shareOptions)
          break
        // 分享图片到微信好友 图片 -> base64
        case 3:
          break
      }
    },
    bindScroll(e) {
      if (!this.isApp) {
        return
      }
      let minHeight = 50
      let maxHeight = 100
      var scroll = Math.round(e.target.scrollTop)
      if (scroll < minHeight) {
        this.navBarOpacity = 0
      }
      if (scroll > maxHeight) {
        this.navBarOpacity = 1
      } else {
        let pecent = (scroll - minHeight) / (maxHeight - minHeight)
        this.navBarOpacity = parseFloat(pecent.toFixed(2))
      }
    },
    async getActivityInfo(current_day = '') {
      let params = {
        current_day
      }
      let cur = this.curNav
      if (this.navList[this.curNav] && !this.navList[this.curNav].loaded) {
        this.isLoading = true
      }
      let url = this.isApp
        ? 'api/v1/ActivityForGym/index'
        : 'api/v1/ActivityForGym/shareIndex'
      let res = await this.$http.getApp(url, params).catch(() => {})
      this.isLoading = false
      if (this.navList[cur]) {
        this.navList[cur].loaded = true
      }
      if (res) {
        res = res.data
        // res = deepClone(activityInfo);
        if (res.code == 200) {
          let data = this.dealActivityData(res.data)
          if (!this.navList.length && data.nav) {
            this.initNavTab(data.nav)
            this.autoScrollNav()
          }
          this.activityData = res.data
          cur = current_day
            ? cur
            : this.navList.findIndex((item) => {
                return item.selected
              })
          this.addData(data, cur)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    allowShowErrToast(type, position) {
      this.errorType = type
      //1-正常能够参与活动的用户，2-不是指定的卡的gym用户，3-非gym用户
      if (type == 2) {
        this.bindshowNotQualified()
        return true
      } else if (type == 3 && position == 'myPrize') {
        return false
      } else if (type == 3 && position !== 'myPrize') {
        this.bindshowNotQualified()
        return true
      }
    },
    autoScrollNav() {
      this.$nextTick(() => {
        let el = this.$refs.tab
        let child = this.$refs.tabItem
        child = child[0]
        el.scrollLeft = child.clientWidth * this.curNav
      })
    },
    //把数据添加到指定tab下
    addData(data, curNav) {
      if (curNav < 0) {
        return
      }
      this.navList.map((item, index) => {
        for (let key in data.nav[index]) {
          /* 跳过更新data */
          if (key !== 'data') {
            item[key] = data.nav[index][key]
          }
        }
      })
      this.navList[curNav].data = data.data
      this.navList[curNav].loaded = true
    },
    initNavTab(nav) {
      this.navList = nav
      this.curNav =
        this.navList.findIndex((item) => {
          return item.selected
        }) || 0
    },
    dealActivityData(data) {
      let res = {}
      if (data && data.every_day_study_state) {
        data.every_day_study_state.map((item) => {
          item.statusText = this.getStatusText(item)
          item.data = {}
        })
      }
      res.nav = data.every_day_study_state || []
      delete data.every_day_study_state
      res.data = data
      return res
    },
    getStatusText(item) {
      if (item.prize_state == 3) {
        return '已中奖'
      } else if (item.prize_state == 2) {
        return '未中奖'
      } else if (item.is_participate == 2) {
        return '已参与'
      } else {
        return '未参与'
      }
    },
    async getBigAward() {
      let res = await this.$http
        .getApp('api/v1/ActivityForGym/getBigAward', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.bigAwardData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindAppointment() {
      let res = this.allowShowErrToast(this.activityData.user_state)
      if (res) {
        return
      }
      this.$http.bindH5UMA('CLICK_JM_EVENTS_kcdk_GO')
      let todayIndex = this.navList.findIndex((item) => {
        return item.is_today == 1
      })
      let appointmentIndex =
        todayIndex >= this.curNav ? todayIndex : this.curNav
      let url =
        location.origin +
        '/subscribe?day=' +
        this.navList[appointmentIndex].date
      this.$betterwe.jumpRoute(
        `/web?url=${encodeURIComponent(url)}&isJM=1&isAddToken=false`
      )
    },
    async getAddressData() {
      if (!this.isApp) {
        return
      }
      let res = await this.$http
        .getApp('api/v1/ActivityForGym/getAddress', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data) {
            this.addressData = res.data
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async setAddressData(data) {
      let params = data
      this.loading = true
      let res = await this.$http
        .getApp('api/v1/ActivityForGym/setAddress', params)
        .catch(() => {})
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('提交成功')
          this.getAddressData()
          this.showFillAddress = false
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.spring-festival-course-reservation {
  height: 100vh;
  overflow-y: scroll;
  box-sizing: border-box;
  ::v-deep .van-popup {
    background-color: transparent;
    overflow-y: visible;
  }
  .my-prize {
    width: 28px;
    box-sizing: border-box;
    text-align: center;
    padding: 5px 5px;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 4px 0px 0px 4px;
    right: 0;
    top: 150px;
    z-index: 1;
    font-weight: bold;
    font-size: 12px;
    line-height: 14px;
    color: #fff;
  }
  .app-loading {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .container {
    position: relative;
    z-index: 0;
    min-height: 100vh;
    overflow: hidden;
    background: #d93740;
    .bg-image {
      position: absolute;
      z-index: -1;
      left: 0;
      top: 0;
      width: 100%;
    }
    .city-container {
      padding: 0px 12px;
      margin-top: 425px;
      height: 20px;
      display: flex;
      align-items: center;
      .city {
        padding: 0px 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 20px;
        background: rgba(122, 0, 0, 0.5);
        border-radius: 10px;
        font-weight: bold;
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        .iconfont {
          font-size: 12px;
          font-weight: normal;
          margin-right: 2px;
        }
      }
    }
    .tab-container {
      margin-top: -12px;
      padding-top: 20px;
      overflow-y: hidden;
      overflow-x: scroll;
      margin-bottom: 6px;
      .tab-list {
        padding: 0px 12px;
        display: inline-flex;
        align-items: center;
        .tab-item {
          position: relative;
          width: 72px;
          height: 68px;
          text-align: center;
          white-space: nowrap;
          margin-right: 10px;
          display: flex;
          flex-direction: column;
          align-items: stretch;
          justify-content: center;
          background: linear-gradient(152deg, #ffa45b 0%, #ff7a1f 100%);
          box-shadow: 0px 2px 4px 0px rgba(180, 0, 19, 0.71);
          border-radius: 6px;
          border: 1px solid #ffb173;
          color: #fff;
          margin-top: 3px;
          .item-day {
            font-weight: bold;
            font-size: 11px;
            line-height: 16px;
          }
          .item-date {
            font-family: MiSans, MiSans;
            font-weight: bold;
            font-size: 14px;
            line-height: 19px;
          }
          .item-status {
            font-size: 11px;
            line-height: 16px;
          }
          .gift-image {
            position: absolute;
            width: 27px;
            height: 27px;
            right: -7px;
            top: -13px;
            object-fit: contain;
          }
        }
        .tab-item:last-child {
          margin-right: 0px;
        }
        .tab-item-active {
          margin-top: 0px;
          position: relative;
          z-index: 1;
          color: rgba(185, 18, 36, 1);
          width: 88px;
          height: 85px;
          /* background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/0d738ae3a69842daaf96e55a7d34ffb8_wh=264_258.png');
          background-repeat: no-repeat;
          background-size: 100%; */
          background: none;
          border: none;
          /* background: linear-gradient(180deg, #ffffff 0%, #ffd3a3 100%); */
          box-shadow: none;
        }
        .tab-item-active::after {
          content: '';
          z-index: -3;
          position: absolute;
          top: 0px;
          left: 0px;
          width: 88px;
          height: 80px;
          border-radius: 6px;
          box-shadow: 0px 2px 6px 0px #a91314;
        }
        .tab-item-active::before {
          content: '';
          z-index: -1;
          position: absolute;
          top: 0px;
          left: 0px;
          width: 88px;
          height: 85px;
          background-image: url('https://btw-common-data.betterwestar.com/btw-admin/admin-common-data/2025-01/0d738ae3a69842daaf96e55a7d34ffb8_wh=264_258.png');
          background-repeat: no-repeat;
          background-size: 100%;
        }
      }
    }
    .tab-view-container {
      .tab-view-item {
        min-height: 50vh;
        .tab-wrapper {
          .wrapper-padding {
            padding: 0px 12px;
          }
        }
      }
    }
  }
  .logo {
    width: 100%;
    height: 91px;
  }
  .fill-address {
    transition: none;
    transition-duration: 0;
  }
}
</style>
